/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年09月10日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	voucherCount() {
		return Ajax.get("/home/voucher/count")
	},
	//财务指标：应收账款/应付账款/银行存款/库存现金/固定资产期末余额
	financialMetrics() {
		return Ajax.get("/home/financialMetrics")
	},
	chart: {
		revenueProfit() {
			return Ajax.get("/home/chart/revenueProfit")
		},
		cost() {
			return Ajax.get("/home/chart/cost")
		},
		cash() {
			return Ajax.get("/home/chart/cash")
		}
	}
}